import type { Role } from './state/OrgContext'

/** Backend raw-USD → displayed-USD markup factor (profit margin). */
export const UI_COST_MULTIPLIER = 3;

/** Format a raw backend compute_cost (LLM USD) for admin display (with markup). */
export const formatDisplayedUsd = (rawValue: number): string => {
  const value = Number(rawValue || 0) * UI_COST_MULTIPLIER;
  if (value <= 0) return "$0.00";
  if (value < 0.01) return `$${value.toFixed(6)}`;
  return `$${value.toFixed(4)}`;
};

/** Format a raw compute_cost as plain USD (no markup) — for showing actual LLM cost to admin. */
export const formatComputeCost = (rawValue: number): string => {
  const value = Number(rawValue || 0);
  if (value <= 0) return "$0.00";
  if (value < 0.01) return `$${value.toFixed(6)}`;
  return `$${value.toFixed(4)}`;
};

/** Format a credit amount for display. */
export const formatCredits = (credits: number): string => {
  return `${credits.toFixed(2)} kredi`;
};

/** Format a read-credit amount for display. */
export const formatReads = (reads: number): string => {
  const rounded = Math.floor(reads);
  return `${rounded.toLocaleString()} okuma`;
};

/**
 * Role-aware cost formatter.
 * - ADMIN      → sees monetary cost in USD  (formatDisplayedUsd)
 * - ORG_MANAGER → returns null (should use credit_amount from transaction directly)
 * - TEACHER    → returns null (not shown)
 */
export const formatCostForRole = (
  rawValue: number,
  role: Role,
): string | null => {
  if (role === 'ADMIN') return formatDisplayedUsd(rawValue);
  return null;
};
